import React, { useState, useEffect } from 'react';
import { useGetGoogleAuthUrlQuery } from '../../../redux/apis/endpoints/authApi';

const SocialLoginButtons = () => {
  // Add state to track loading status per provider
  const [isLoading, setIsLoading] = useState({
    google: false
  });
  
  // State to control when the query should run
  const [shouldFetch, setShouldFetch] = useState(false);
  
  // Always use dashboard as the return path to avoid any issues with OAuth redirects
  const defaultRedirectTo = '/dashboard';
  
  // Now use the query hook with dynamic skip
  const { data: googleAuthData, isError, error } = useGetGoogleAuthUrlQuery(defaultRedirectTo, {
    skip: !shouldFetch,
    onQueryStarted: () => {
      console.log('Google auth URL query started');
    }
  });
  
  // Watch for data coming back from the query
  useEffect(() => {
    if (shouldFetch && googleAuthData && googleAuthData.authUrl) {
      console.log(`Received Google auth URL from API: ${googleAuthData.authUrl}`);
      
      // Reset the fetch trigger
      setShouldFetch(false);
      
      // Redirect to Google for authentication
      window.location.href = googleAuthData.authUrl;
    }
  }, [shouldFetch, googleAuthData]);
  
  // Watch for errors
  useEffect(() => {
    if (isError && error) {
      console.error('Error fetching Google auth URL:', error);
      alert('Failed to connect to Google. Please try again later.');
      setShouldFetch(false);
      setIsLoading({ ...isLoading, google: false });
    }
  }, [isError, error, isLoading]);
  
  // Handle click on social login button
  const handleSocialLogin = (provider) => {
    if (provider === 'google') {
      console.log('Triggering Google auth URL fetch from backend API...');
      setIsLoading({ ...isLoading, google: true });
      setShouldFetch(true);
    }
  };

  return (
    <div className="mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-white px-2 text-gray-500">
            Or continue with
          </span>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-3">
        <button
          type="button"
          onClick={() => handleSocialLogin('google')}
          disabled={isLoading.google}
          className="flex w-full items-center justify-center gap-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12.0003 4.75C13.7703 4.75 15.3553 5.36002 16.6053 6.54998L20.0303 3.125C17.9502 1.19 15.2353 0 12.0003 0C7.31028 0 3.25526 2.69 1.28027 6.60998L5.27028 9.70498C6.21525 6.86002 8.87028 4.75 12.0003 4.75Z" fill="#EA4335" />
            <path d="M23.49 12.275C23.49 11.49 23.415 10.73 23.3 10H12V14.51H18.47C18.18 15.99 17.34 17.25 16.08 18.1L19.945 21.1C22.2 19.01 23.49 15.92 23.49 12.275Z" fill="#4285F4" />
            <path d="M5.26498 14.2949C5.02498 13.5699 4.88501 12.7999 4.88501 11.9999C4.88501 11.1999 5.01998 10.4299 5.26498 9.7049L1.275 6.60986C0.46 8.22986 0 10.0599 0 11.9999C0 13.9399 0.46 15.7699 1.28 17.3899L5.26498 14.2949Z" fill="#FBBC05" />
            <path d="M12.0004 24C15.2404 24 17.9654 22.935 19.9454 21.095L16.0804 18.095C15.0054 18.82 13.6204 19.245 12.0004 19.245C8.8704 19.245 6.21537 17.135 5.2704 14.29L1.27539 17.385C3.25537 21.31 7.3104 24 12.0004 24Z" fill="#34A853" />
          </svg>
          <span>{isLoading.google ? 'Connecting...' : 'Google'}</span>
        </button>
      </div>
    </div>
  );
};

export default SocialLoginButtons; 